import styled from 'styled-components';

export const PageItem = styled('button')`
  ${({
    theme: {
      colors, spacing, rounded, breakpoint,
    },
  }) => `
    border: 1px solid ${colors.grey2};
    border-radius: ${rounded.px10};
    background: ${colors.white};
    margin-bottom: ${spacing.px15};
    padding-left:0;
    padding-top:0;
    padding-bottom:0;
    overflow:hidden;
    max-width: 326px;
    min-width:326px;
    min-height: 56px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    outline: none;
    box-sizing: border-box;
    &:hover {
        background: ${colors.grey3};
    }
    @media screen and (max-width: ${breakpoint.sm}) {
        min-width: 240px;
        width: 240px;
    }
  `}
`;

export const PageImage = styled('figure')`
  ${({ theme: { spacing } }) => `
    margin: ${spacing.none} ${spacing.px10} ${spacing.none} ${spacing.none};
    width: 56px;
    aling-items: center;
    & > img {
        width: 56px;
        height: 56px;
        max-width: 56px;
    }
  `}
`;

export const PageInfo = styled('div')`
  ${({ theme: { spacing } }) => `
    margin: ${spacing.none} ${spacing.none} ${spacing.none} ${spacing.px10};
    width: 100%;
    text-align: left;
  `}
`;

export const PageName = styled('div')`
  ${({ theme: { fontSize, colors } }) => `
    font-size: ${fontSize.px16};
    color: ${colors.blueGrey2};
  `}
`;
